/**
 * Book Narrative POV settle (#1277).
 * Person, Don't know yet, one/several, viewpoint cast.
 * Not Voice. Not scene Whose head.
 */
import {
  POV_HELP_CLOSE,
  POV_HELP_FIRST_ONE,
  POV_HELP_FIRST_SEVERAL,
  POV_HELP_LIMITED,
  POV_HELP_LIMITED_ONE,
  POV_HELP_LIMITED_SEVERAL,
  POV_HELP_OMNISCIENT,
} from './writerCopy';

export const POV_DEFERRED_VALUE = '__deferred__';

export function povNeedsSettle(bookPov) {
  if (!bookPov) return false;
  if (bookPov.deferred || bookPov.status === 'deferred') return true;
  return !bookPov.mode;
}

export function povBlocksWork() {
  /** Soft chip only. Focus, Confirm, Generate, and Draft stay open. */
  return false;
}

export function cameraShown(person, deferred) {
  if (deferred || person === POV_DEFERRED_VALUE) return false;
  if (!person || person === 'omniscient') return false;
  return true;
}

export function helpText({ person, camera, deferred }) {
  if (deferred || person === POV_DEFERRED_VALUE || !person) return '';
  const lines = [];
  if (person === 'close_third') lines.push(POV_HELP_CLOSE);
  if (person === 'limited_third') lines.push(POV_HELP_LIMITED);
  if (person === 'omniscient') lines.push(POV_HELP_OMNISCIENT);
  if (person === 'first_person' && camera === 'one') lines.push(POV_HELP_FIRST_ONE);
  if (person === 'first_person' && camera === 'several') lines.push(POV_HELP_FIRST_SEVERAL);
  if (person === 'limited_third' && camera === 'one') lines.push(POV_HELP_LIMITED_ONE);
  if (person === 'limited_third' && camera === 'several') lines.push(POV_HELP_LIMITED_SEVERAL);
  return lines.join(' ');
}

export function draftFromBookPov(bookPov) {
  const deferred = Boolean(bookPov?.deferred || bookPov?.status === 'deferred');
  const person = deferred ? POV_DEFERRED_VALUE : (bookPov?.mode || '');
  let camera = deferred ? '' : (bookPov?.camera || '');
  const entityId = deferred ? '' : (bookPov?.entity_id || '');
  if (!deferred && cameraShown(person, false) && !camera && entityId) {
    camera = 'one';
  }
  return {
    person,
    camera,
    entityId: camera === 'several' ? '' : entityId,
    castIds: deferred || camera !== 'several'
      ? []
      : (bookPov?.cast || []).map((item) => item.entity_id).filter(Boolean),
  };
}

export function bookPovSaveArgs(draft, people = []) {
  const deferred = draft.person === POV_DEFERRED_VALUE;
  const mode = deferred ? null : (draft.person || null);
  const camera = cameraShown(draft.person, deferred) ? (draft.camera || null) : null;
  let povEntityId = null;
  let bibleEntryId = null;
  if (camera === 'one' && draft.entityId) {
    const person = (people || []).find((item) => item.pickId === draft.entityId);
    if (person) {
      povEntityId = person.character_entity_id || null;
      bibleEntryId = person.bible_entry_id || null;
      if (!povEntityId && !bibleEntryId) povEntityId = draft.entityId;
    } else {
      povEntityId = draft.entityId;
    }
  }
  const povCast = camera === 'several'
    ? (draft.castIds || []).map((id) => {
      const person = (people || []).find((item) => item.pickId === id);
      return person?.character_entity_id || person?.bible_entry_id || id;
    })
    : [];
  return {
    povMode: mode,
    povEntityId,
    bibleEntryId,
    povDeferred: deferred,
    povCamera: camera,
    povCast,
  };
}

export function castIdsFromBookPov(bookPov) {
  if (!bookPov || bookPov.deferred || bookPov.status === 'deferred') return null;
  if (!bookPov.mode || bookPov.camera !== 'several') return null;
  const ids = (bookPov.cast || []).map((person) => person.entity_id).filter(Boolean);
  return ids.length ? ids : null;
}

export function personOutsideCast(value, castIds) {
  if (!castIds || !castIds.length) return false;
  if (!value || value.choice !== 'person' || !value.entityId) return false;
  return !castIds.map(String).includes(String(value.entityId));
}
